import { CodeTitle, IdTitle } from '../types';

export const transformCodeTitleToIdTitle = (obj: CodeTitle): IdTitle => {
    const { code, title } = obj;
    return {
        id: code,
        title,
    };
};
